import { render, staticRenderFns } from "./myEventOrder.vue?vue&type=template&id=2b53f19e&scoped=true&"
import script from "./myEventOrder.vue?vue&type=script&lang=js&"
export * from "./myEventOrder.vue?vue&type=script&lang=js&"
import style0 from "./myEventOrder.vue?vue&type=style&index=0&id=2b53f19e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53f19e",
  null
  
)

export default component.exports